<div class="container-fluid" *ngIf="_modulService.formHideShow==0">
    <!-- <div class="row flex-body">
        <div class="col-md-11 col-md-offset-1">
            <div class="box">
                <h4 class="box-title">Module</h4>
            </div>
            <div class="col-md-4 offset-md-8 searchBox">
                <div class="form-group row no-gutters">
                    <div class="col-12 col-sm-6 col-md-2"><button type="button" class="btn-sm btn-info"
                            (click)="addList()"><i class="fas fa-plus" aria-hidden="true"></i></button></div>
                    <div class="col-12 col-sm-6 col-md-8"><input type="text" class="form-control-search" name="search"
                            [(ngModel)]="term"></div>
                    <div class="col-6 col-md-2"><button class="btn-info"><i class="fas fa-search"
                                aria-hidden="true"></i></button>
                    </div>
                </div>
            </div> -->
    <h2 class="heading_all">MODULE</h2>
    <br>
    <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4"></div>
        <div class="col-md-4 ">

            <table>
                <thead>
                    <tr>
                        <td>
                            <button type="button" class="btn-sm btn-info" (click)="addList()"><i class="fas fa-plus"
                                    aria-hidden="true"></i></button>
                        </td>
                        <td style="width: 70%;"><input type="text" class="form-control-search" name="search"
                                [(ngModel)]="term"></td>
                        <td><button class="btn-info"><i class="fas fa-search" aria-hidden="true"></i></button></td>
                    </tr>
                </thead>
            </table>

        </div>
    </div>

    <table>
        <thead>
            <tr>
                <th>#</th>
                <!-- <th (click)="sort('name')">Module Code</th>
                        <th (click)="sort('code')"> Module Name</th>
                        <th>Action</th> -->
                <th class="hidden-xs">
                    <div class="AtjIsPoint" (click)="sort('ModuleCode')">
                        <span *ngIf="!_modulService.isFiltering">Module Code</span>
                        <div class="AtjfloatRight">
                            <i class="fas fa-sort" *ngIf="_modulService.orderByColName!='ModuleCode' "></i>
                            <div *ngIf="_modulService.orderByColName=='ModuleCode'">
                                <i class="fas fa-sort-amount-down" *ngIf="_modulService.orderByDir"></i>
                                <i class="fas fa-sort-amount-up-alt" *ngIf="!_modulService.orderByDir"></i>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="_modulService.isFiltering">
                        <input type="text" #txtModuleCodeFilter="ngModel" [(ngModel)]="_modulService.ModuleCodeFilter"
                            placeholder="ModuleCode">
                    </div>

                </th>
                <th class="hidden-xs">
                    <div class="AtjIsPoint" (click)="sort('ModuleName')">
                        <span *ngIf="!_modulService.isFiltering">Module</span>
                        <div class="AtjfloatRight">
                            <i class="fas fa-sort" *ngIf="_modulService.orderByColName!='ModuleName' "></i>
                            <div *ngIf="_modulService.orderByColName=='ModuleName'">
                                <i class="fas fa-sort-amount-down" *ngIf="_modulService.orderByDir"></i>
                                <i class="fas fa-sort-amount-up-alt" *ngIf="!_modulService.orderByDir"></i>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="_modulService.isFiltering">
                        <input type="text" #txtModuleFilter="ngModel" [(ngModel)]="_modulService.ModuleNameFilter"
                            placeholder="ModuleName">
                    </div>

                </th>
                <th><em></em> Settings
                    <a class="AtjIsPoint AtjfloatRight" (click)="toggleFilter()">
                        <i *ngIf="!_modulService.isFiltering" class="fas fa-filter"></i>
                        <i *ngIf="_modulService.isFiltering" class="fas fa-times"></i>
                    </a>
                </th>
            </tr>
        </thead>
        <tbody>
            <!-- ngRepeat: item in items -->
            <!-- <tr *ngFor="let modul of _modulService.allModules | orderBy: key : reverse | filter:term | paginate: { itemsPerPage: NoOfItems, currentPage: p }; let i = index"
                        class="ng-scope"> -->
            <tr *ngFor="let modul of _modulService.allModules | orderBy : 'ModuleName' | gridOperations  :_modulService.pageIndex: 
                        {ModuleCode:_modulService.ModuleCodeFilter,ModuleName:_modulService.ModuleNameFilter}:
                       {Column:_modulService.orderByColName,Dir:_modulService.orderByDir} ; let i = index"
                class="ng-scope">
                <td>{{i+1+((NoOfItems*_modulService.pageIndex)-NoOfItems)}}</td>
                <td>{{modul.ModuleCode}}</td>
                <td>{{modul.ModuleName}}</td>
                <td>
                    <button type="button" class="btn-success" (click)="showForEdit(modul)">
                        <i class="fas fa-pen-square" aria-hidden="true"></i></button>
                    <button type="button" class="btn-danger" (click)="onDelete(modul)"><i class="fas fa-trash"
                            aria-hidden="true"></i></button>
                </td>
            </tr><!-- end ngRepeat: item in items -->
            <tr>
                <td colspan="4" *ngIf="(_modulService.allModules?.length<=0 )  || _CommonService.filterdItemCount<1">
                    No Records To
                    Display.</td>
            </tr>
        </tbody>
        <tfoot>
            <td colspan="4" *ngIf="_CommonService.totalPageCount>1">
                <app-grid-pagination (pageIndexValue)="_modulService.pageIndex=$event">
                </app-grid-pagination>
            </td>
        </tfoot>
    </table>
    <!-- <pagination-controls (pageChange)="p = $event"></pagination-controls> -->
    <div class="margintop"></div>
    <!-- </div>
    </div> -->
</div>
<app-delete-confirm *ngIf="deletePopUp" [title]="'MODULE'" (ConfirmEvent)="dialogResult($event)"></app-delete-confirm>